var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareNobg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 27.0003C21.2092 27.0003 23.0001 25.2095 23.0001 23.0003C23.0001 20.7911 21.2092 19.0002 19 19.0002C16.7909 19.0002 15 20.7911 15 23.0003C15 25.2095 16.7909 27.0003 19 27.0003Z",
    stroke: "#738395",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.00009C21.2092 9.00009 23.0001 7.20921 23.0001 5.00004C23.0001 2.79088 21.2092 1 19 1C16.7909 1 15 2.79088 15 5.00004C15 7.20921 16.7909 9.00009 19 9.00009Z",
    stroke: "#738395",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 18.0003C7.20921 18.0003 9.00009 16.2095 9.00009 14.0003C9.00009 11.7911 7.20921 10.0002 5.00004 10.0002C2.79088 10.0002 1 11.7911 1 14.0003C1 16.2095 2.79088 18.0003 5.00004 18.0003Z",
    stroke: "#738395",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6374 7.1626L8.3623 11.8376",
    stroke: "#738395",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3623 16.1626L15.6374 20.8376",
    stroke: "#738395",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNobg);
export default __webpack_public_path__ + "static/media/share-nobg.12106afd5fc322bee9b5d5651719ee45.svg";
export { ForwardRef as ReactComponent };